var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CategorySearchOptions",
    _vm._g(
      {
        ref: "searchOptions",
        attrs: { selectedCategory: _vm.selectedCategory },
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }